// extracted by mini-css-extract-plugin
module.exports = {"Button":"button-module--Button--3S725","ButtonSolid":"button-module--Button--solid--2Lxad","Button__icon":"button-module--Button__icon--1wlP7"};